<table class="table pr-3" style="border: 0">
  <thead>
    <tr>
      <th *ngFor="let column of columns" class="col-auto" style="border: 0px !important">
        {{ column.name }}
      </th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let item of list; index as IndexItem" class="row-item">
      <td
        *ngFor="let column of columns; index as IndexColumn"
        class="col-auto"
        [ngStyle]="{
          'border-radius': IndexColumn == 0 ? '8px 0 0 8px' : IndexColumn == columns.length - 1 ? '0 8px 8px 0' : ''
        }"
      >
        <ng-container *ngIf="column.variable == 'svg'">
          <div>
            <div class="div-sign-icon">
              <div
                *ngIf="!item.complementInformationType"
                [ngClass]="item.signCode | enumCaption: 'Caption':40"
                class="position-relative internal-caption"
              >
                <span>{{ item?.verticalType != verticalSignTypeEnum.Indication ? item.internalCaption : '' }}</span>
                <img src="{{ item[column.variable] }}" style="width: 40px; height: 40px" />
              </div>

              <div
                *ngIf="item.type == typeSignEnum.Vertical && item.complementInformationType"
                class="d-flex justify-content-center"
                style="height: 48px; width: 40px"
              >
                <img
                  *ngIf="item.complementInformationType == complementInformationType.Additional"
                  [src]="complementType(item) | enumSvg: 'ComplementInformation'"
                  style="width: 40px; height: 20px; position: absolute; object-fit: contain; bottom: 10px"
                />
                <img
                  *ngIf="item.complementInformationType == complementInformationType.Incorporated"
                  [src]="complementType(item) | enumSvg: 'ComplementInformation'"
                  style="width: 40px; height: 60px; position: absolute; object-fit: contain; bottom: 8px"
                />
                <div
                  [ngClass]="item.signCode | enumCaption: 'Caption':32"
                  class="position-relative internal-caption"
                  style="height: 32px; width: 32px"
                >
                  <span class="position-absolute" style="z-index: 1">{{
                    item?.verticalType != verticalSignTypeEnum.Indication ? item.internalCaption : ''
                  }}</span>
                  <img
                    [src]="item.signCode | enumSvg: 'Signaling':signType"
                    style="width: 32px; height: 32px; object-fit: contain; position: absolute"
                  />
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="column.variable == 'warranty' || column.variable == 'executionDate'">
          <div
            [ngStyle]="{
              color:
                column.variable == 'warranty'
                  ? dateService.isWithinEndOfWarranty(item.warrantyCurrent)
                    ? 'var(--red-base)'
                    : 'var(--greenmix-light)'
                  : ''
            }"
          >
            {{ item[column.variable] | date: 'dd/MM/yy' }}
          </div>
        </ng-container>

        <ng-container *ngIf="column.nameOnly">
          <div>
            {{ item[column.variable] ?? '-' }}
          </div>
        </ng-container>
      </td>
    </tr>
  </tbody>
</table>
